import React from 'react';
import { Link } from 'react-router-dom';

import CheckMark  from "../CheckMark";
import CheckinImg from "~/assets/images/dailyGoals/check-in.png";


const DailyCheckinsGoal = ({status}) => {

  return (
    <Link className="item-goal" to={"/check-in"}>
      <CheckMark done={status.completed} />
      <div>
        <h5 className={"item-title"}> {4 - status.checkins !== 0 ?  4 - status.checkins + (status.checkins === 3 ? " Check-in" : " Check-ins") : "Check-in"} </h5>
        <p> Complete the checkin and earn <strong>10</strong> points by simply completing the hcaptcha </p>
      </div>
      <img src={CheckinImg} className="icon"/>
    </Link>
  )
}

export default DailyCheckinsGoal;
